import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import cn from "clsx";
import { Col, PrimaryButton, Row } from "@crehana/ui";
import useNewDashboardContext from "./context/useNewDashboardContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NewDashboardEmptyView = function NewDashboardEmptyView(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    isDarkProp = _ref.isDark,
    title = _ref.title,
    description = _ref.description,
    button = _ref.button,
    supportsDarkMode = _ref.supportsDarkMode,
    dataTestId = _ref['data-testid'];
  var _useNewDashboardConte = useNewDashboardContext(),
    isDark = _useNewDashboardConte.isDark;
  var dark = supportsDarkMode && (isDarkProp || isDark);
  var textColor = dark ? 'text-white' : 'text-base-main';
  return /*#__PURE__*/_jsx("div", {
    className: cn('w-full', dark ? 'bg-base-lighter-24' : 'bg-base-lighter-16', className),
    "data-testid": dataTestId,
    children: /*#__PURE__*/_jsx(Row, {
      nowrap: true,
      className: "flex justify-center",
      children: /*#__PURE__*/_jsx(Col, {
        xs: 12,
        sm: 10,
        lg: 8,
        children: /*#__PURE__*/_jsxs("div", {
          className: cn('flex flex-col items-center text-center py-16 px-16 sm:py-32 sm:px-0', textColor),
          children: [typeof title === 'string' ? /*#__PURE__*/_jsx("h4", {
            className: "font-h4 whitespace-pre-line",
            children: title
          }) : title, typeof description === 'string' ? /*#__PURE__*/_jsx("span", {
            className: cn("font-body3 whitespace-pre-line", title ? 'mt-16' : ''),
            children: description
          }) : description, button && /*#__PURE__*/_jsx(PrimaryButton, _objectSpread({
            className: cn("w-full sm:w-auto", title || description ? 'mt-16' : ''),
            size: "l",
            darkMode: dark
          }, button))]
        })
      })
    })
  });
};
export default NewDashboardEmptyView;